import React from "react";
import { Link } from "react-router-dom";
import { Refrigerator, WashingMachine, Fan, Utensils, Zap, CheckCircle2 } from "lucide-react";

const catalog = [
  { icon: Refrigerator, name: "Refrigerators & Freezers", items: ["Not cooling / warm interior", "Ice-maker not producing", "Leaking water", "Door seal / gasket replacement", "Compressor & fan diagnostics"] },
  { icon: WashingMachine, name: "Washing Machines", items: ["Won't drain or spin", "Excessive vibration", "Won't fill / won't stop filling", "Leaking hoses & pumps", "Control board failures"] },
  { icon: Fan, name: "Dryers", items: ["No heat / burning smell", "Won't tumble", "Loud drum noise", "Vent cleaning & safety check", "Belt & idler replacements"] },
  { icon: Utensils, name: "Ovens & Ranges", items: ["Won't heat / uneven bake", "Bad igniter or element", "Broken door hinge / glass", "Control panel repair", "Gas & electric — all makes"] },
  { icon: Zap, name: "Dishwashers", items: ["Not draining / standing water", "Not cleaning properly", "Leaking under the unit", "Detergent dispenser stuck", "Motor & pump swaps"] },
];

export default function Services() {
  return (
    <div className="max-w-7xl mx-auto px-6 md:px-10 py-16">
      <div className="text-mono-label">Services</div>
      <h1 className="font-display font-black text-5xl md:text-6xl mt-4 tracking-tighter">What we fix.</h1>
      <p className="mt-4 text-[#475569] max-w-2xl">Every major residential appliance, every major brand. Below is what usually walks through the door — but if it isn't listed, ask.</p>

      <div className="mt-14 space-y-6">
        {catalog.map((c, i) => (
          <div key={c.name} className="card-industrial p-8 md:p-10 grid grid-cols-1 md:grid-cols-12 gap-6">
            <div className="md:col-span-4">
              <div className="flex items-center gap-3">
                <c.icon className="w-8 h-8 text-brand" />
                <span className="font-mono text-xs text-[#94A3B8]">/ 0{i + 1}</span>
              </div>
              <h2 className="mt-4 font-display font-black text-3xl">{c.name}</h2>
            </div>
            <div className="md:col-span-6">
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {c.items.map((it) => (
                  <li key={it} className="flex items-start gap-2 text-sm text-[#0F172A]"><CheckCircle2 className="w-4 h-4 text-brand mt-0.5 shrink-0" /> {it}</li>
                ))}
              </ul>
            </div>
            <div className="md:col-span-2 flex md:flex-col items-start md:items-end justify-end">
              <Link to="/book" data-testid={`services-book-${c.name.split(' ')[0].toLowerCase()}`} className="btn-brand">Book</Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
